import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vShow as _vShow, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-775f3da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "modal7"
}
const _hoisted_5 = { class: "contenedor7" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Aseguradoras ", -1))
const _hoisted_7 = { class: "contenido7" }
const _hoisted_8 = { class: "contenido7" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "general" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_12 = { class: "grid" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo,"
}, "Tipo de Reclamación:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cent" }, "Centro", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "med" }, "Médico", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "facNo,"
}, "Factura No.:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechAutor,"
}, "Fecha:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombARS,"
}, "Nombre de la ARS:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Prestador")
], -1))
const _hoisted_21 = { class: "grid" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombPres,"
}, "Nombre:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "espec,"
}, "Especialidad:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "exeq,"
}, "Exequatur:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telMed,"
}, "Teléfono:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "codPres,"
}, "Código:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "med,"
}, "Médico:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de la Reclamación")
], -1))
const _hoisted_29 = { class: "grid" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "aut,"
}, "Autorización:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "naf,"
}, "NAF:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "autPor,"
}, "Autorizado Por:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipServ,"
}, "Tipo de Servicio:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Consulta", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Emergencia", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Cirugía", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Hospitalización", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Procedimiento Ambulatorio", -1))
const _hoisted_39 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "descServ,"
}, "Descripción de Servicio:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "montRec,"
}, "Total:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "montRec,"
}, "Cobertura:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "montRec,"
}, "Copago:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Caso")
], -1))
const _hoisted_45 = { class: "grid" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombPac"
}, "Nombre del Paciente:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cedu,"
}, "Cédula:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "aflNSS,"
}, "Afiliado o NSS:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "sex,"
}, "Sexo:", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Masculino", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Femenino", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "edad,"
}, "Edad:", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "dir,"
}, "Dirección:", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "ing,"
}, "Ingreso:", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "egr,"
}, "Egreso:", -1))
const _hoisted_57 = { class: "grid" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "dx,"
}, "Diagnóstico:", -1))
const _hoisted_59 = ["disabled"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = ["disabled"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print" }, null, -1))
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Imprimir ")
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.showModalAseguradoras)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "search",
                      type: "search",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                      class: "form-control",
                      onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buscar()))
                    }, null, 544), [
                      [_vModelText, _ctx.search]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seguros2, (seguro, index) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "ars",
                        style: {"cursor":"pointer"},
                        key: index,
                        onClick: ($event: any) => (_ctx.setSeguro(seguro))
                      }, _toDisplayString(seguro), 9, _hoisted_9))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  id: "tipo",
                  type: "tipo",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reclamo.tipo) = $event)),
                  class: "form-select"
                }, _hoisted_16, 512), [
                  [_vModelSelect, _ctx.reclamo.tipo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  id: "facNo",
                  type: "facNo",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reclamo.facNo) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.facNo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  id: "fechAutor",
                  type: "Date",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reclamo.fechAutor) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.fechAutor]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  id: "nombARS",
                  type: "nombARS",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reclamo.nombARS) = $event)),
                  onFocus: _cache[6] || (_cache[6] = ($event: any) => (this.showModalAseguradorasMethod())),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.reclamo.nombARS]
                ])
              ])
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  id: "nombPres",
                  type: "nombPres",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reclamo.nombPres) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.nombPres]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  id: "espec",
                  type: "espec",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.reclamo.espec) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.espec]
                ])
              ], 512), [
                [_vShow, _ctx.isMed()]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  id: "exeq",
                  type: "exeq",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reclamo.exeq) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.exeq]
                ])
              ], 512), [
                [_vShow, _ctx.isMed()]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  id: "telMed",
                  type: "telMed",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.reclamo.telMed) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.telMed]
                ])
              ], 512), [
                [_vShow, _ctx.isMed()]
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  id: "codPres",
                  type: "codPres",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.reclamo.codPres) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.codPres]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  id: "med",
                  type: "med",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.reclamo.med) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.med]
                ])
              ], 512), [
                [_vShow, !_ctx.isMed()]
              ])
            ]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", null, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  id: "aut",
                  type: "aut",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.reclamo.aut) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.aut]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_31,
                _withDirectives(_createElementVNode("input", {
                  id: "naf",
                  type: "naf",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.reclamo.naf) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.naf]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                  id: "autPor",
                  type: "autPor",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.reclamo.autPor) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.autPor]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_33,
                _withDirectives(_createElementVNode("select", {
                  id: "tipServ",
                  type: "tipServ",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.reclamo.tipServ) = $event)),
                  class: "form-select",
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setService()))
                }, _hoisted_39, 544), [
                  [_vModelSelect, _ctx.reclamo.tipServ]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  id: "descServ",
                  type: "descServ",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.reclamo.descServ) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.descServ]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  min: "0",
                  step: "500",
                  id: "montRec",
                  type: "Number",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.reclamo.montTot) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.montTot]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  min: "0",
                  step: "500",
                  id: "montRec",
                  type: "Number",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.reclamo.montRec) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.montRec]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  min: "0",
                  step: "500",
                  id: "montRec",
                  type: "Number",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.reclamo.montCop) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.montCop]
                ])
              ])
            ]),
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", null, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  id: "nombPac",
                  type: "nombPac",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.reclamo.nombPac) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.nombPac]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_47,
                _withDirectives(_createElementVNode("input", {
                  id: "cedu",
                  type: "cedu",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.reclamo.cedu) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.cedu]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  id: "aflNSS",
                  type: "aflNSS",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.reclamo.aflNSS) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.aflNSS]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_49,
                _withDirectives(_createElementVNode("select", {
                  id: "sex",
                  type: "sex",
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.reclamo.sex) = $event)),
                  class: "form-select"
                }, _hoisted_52, 512), [
                  [_vModelSelect, _ctx.reclamo.sex]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_53,
                _withDirectives(_createElementVNode("input", {
                  id: "edad",
                  min: "0",
                  type: "Number",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.reclamo.edad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.edad]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_54,
                _withDirectives(_createElementVNode("input", {
                  id: "dir",
                  type: "dir",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.reclamo.dir) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.dir]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_55,
                _withDirectives(_createElementVNode("input", {
                  id: "ing",
                  type: "Date",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.reclamo.ing) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.ing]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_56,
                _withDirectives(_createElementVNode("input", {
                  id: "egr",
                  type: "Date",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.reclamo.egr) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.reclamo.egr]
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", null, [
                  _hoisted_58,
                  _withDirectives(_createElementVNode("input", {
                    id: "dx",
                    type: "dx",
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.reclamo.dx) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.reclamo.dx]
                  ])
                ])
              ])
            ]),
            (this.modoForm == 'add')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.saveReclamo()), ["prevent"])),
                  disabled: 
                !_ctx.reclamo.facNo ||
                  !_ctx.reclamo.nombPres ||
                  !_ctx.reclamo.codPres ||
                  !_ctx.reclamo.aut ||
                  !_ctx.reclamo.fechAutor ||
                  !_ctx.reclamo.nombARS ||
                  !_ctx.reclamo.autPor ||
                  !_ctx.reclamo.montRec ||
                  !_ctx.reclamo.nombPac ||
                  !_ctx.reclamo.cedu ||
                  !_ctx.reclamo.aflNSS ||
                  !_ctx.reclamo.sex ||
                  !_ctx.reclamo.edad ||
                  !_ctx.reclamo.dir ||
                  !_ctx.reclamo.dx
              
                }, _hoisted_62, 8, _hoisted_59))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-success",
                  onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
                  disabled: 
                !_ctx.reclamo.facNo ||
                  !_ctx.reclamo.nombPres ||
                  !_ctx.reclamo.codPres ||
                  !_ctx.reclamo.aut ||
                  !_ctx.reclamo.fechAutor ||
                  !_ctx.reclamo.nombARS ||
                  !_ctx.reclamo.autPor ||
                  !_ctx.reclamo.montRec ||
                  !_ctx.reclamo.nombPac ||
                  !_ctx.reclamo.cedu ||
                  !_ctx.reclamo.aflNSS ||
                  !_ctx.reclamo.sex ||
                  !_ctx.reclamo.edad ||
                  !_ctx.reclamo.dir ||
                  !_ctx.reclamo.dx
              
                }, _hoisted_66, 8, _hoisted_63))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-warning",
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (this.$router.push(`/reclamos2/${_ctx.reclamo._id}`)))
                }, _hoisted_69))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "btn btn-danger",
                  onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_72))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}